import { styled } from '@mui/material';
import { m } from 'framer-motion';

export const StyledMessageDiv = styled(m.div)(({ theme }) => ({
  '& .message-wrapper': {
    marginBottom: theme.spacing(2),
    maxWidth: theme.spacing(100),
    margin: '0 auto',
    lineHeight: 2,
    width: '100%',
    overflow: 'hidden',
    '&.loading': {
      flexGrow: 1,
      '& .response-wrapper': {
        flexGrow: 1,
      },
    },
    '& .response-wrapper': {
      display: 'flex',
      gap: theme.spacing(1),
      overflow: 'hidden',
      width: '100%',

      '&:hover': {
        '& .player-container': {
          opacity: 1,
        },
      },
    },
  },
  '&.userMessage': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: theme.spacing(1, 3),
    maxWidth: theme.spacing(100),
    margin: '0 auto',
    '& .message-wrapper': {
      display: 'flex',
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius,
      width: 'fit-content',
      borderBottom: 'none',
      margin: 0,
      marginBottom: 0,
      maxWidth: '80%',
      '& .response-wrapper': {
        '& .MuiBox-root': {
          justifyContent: 'flex-end',
        },
      },
    },
  },
}));

export const StyledWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 3),
  width: '100%',
}));
